module.exports = __webpack_public_path__ + "img/application_icon_password_inactive.50077748.png";